/* jshint esversion: 6 */
/* eslint-disable semi */
/* jshint -W024 */
import Vue from 'vue';
import VueRouter from 'vue-router';



import Home from '../views/home/Home.vue';
import recordDepot from '../views/recordDepot/index.vue';
import songDepot from '../views/songDepot/index.vue';
import musicianDepot from '../views/musicianDepot/index.vue';
import companyDepot from '../views/companyDepot/index.vue';
import musicianDetail from '../views/musicianDepot/detail'
import companyDetail from '../views/companyDepot/detail'
import recordDetail from '../views/recordDepot/detail'
import songDetail from '../views/songDepot/detail'
import special from '../views/special/index'
import fav from '../views/fav/index'
import favRecord from '../views/fav/favRecord'
import favSong from '../views/fav/favSong'
import favMC from '../views/fav/favMC'
import favOrg from '../views/fav/favOrg'
import search from '../views/search/index'
import searchRecord from '../views/search/record'
import searchSong from '../views/search/song'
import searchMusician from '../views/search/musician'
import searchCompany from '../views/search/company'




Vue.use(VueRouter);

const routes = [
  // 总库首页
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/search',
    name: 'search',
    component: search,
    children: [
      {
        path: '/search/record',
        name: 'searchRecord',
        component: searchRecord
      },
      {
        path: '/search/song',
        name: 'searchSong',
        component: searchSong,
      },
      {
        path: '/search/musician',
        name: 'searchMusician',
        component: searchMusician,
      },
      {
        path: '/search/company',
        name: 'searchCompany',
        component: searchCompany,
      }
    ]
  },
  {
    path: '/fav',
    name: 'fav',
    component: fav,
    children: [
      {
        path: '/fav/record',
        name: 'favRecord',
        component: favRecord,
      },
      {
        path: '/fav/song',
        name: 'favSong',
        component: favSong,
      },
      {
        path: '/fav/mc',
        name: 'favMC',
        component: favMC,
      }
      ,
      {
        path: '/fav/org',
        name: 'favOrg',
        component: favOrg,
      }
    ]
  },
  {
    path: '/record-depot',
    name: 'recordDepot',
    component: recordDepot
  },
  {
    path: '/rec-info/:id',
    name: 'recordDetail',
    component: recordDetail
  },
  {
    path: '/song-depot',
    name: 'songDepot',
    component: songDepot
  },
  {
    path: '/song-detail/:id',
    name: 'songDetail',
    component: songDetail
  },
  {
    path: '/musician-depot',
    name: 'musicianDepot',
    component: musicianDepot
  },
  {
    path: '/musician-detail/:id',
    name: 'musicianDetail',
    component: musicianDetail
  },
  {
    path: '/company-depot',
    name: 'companyDepot',
    component: companyDepot
  },
  {
    path: '/company-detail/:id',
    name: 'companyDetail',
    component: companyDetail
  },
  {
    path: '/special/:id',
    name: 'special',
    component: special
  }

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});
//路由拦截器
router.beforeEach((to, from, next) => {
  //如果当前路由是去往详情且包含token，则需要把当前路由中携带的id进行编码
  //当前路由中携带了token,储存一下token,然后刷新链接，token不暴漏在链接中
  if (to.query.token) {
    localStorage.setItem('token',to.query.token);
    if (to.path.indexOf('special') != -1 || to.path.indexOf('rec-info') != -1 || to.path.indexOf('song-detail') != -1 || to.path.indexOf('musician-detail') != -1 || to.path.indexOf('company-detail') != -1) {
      let url = to.path.split('http')
      let allUrl = url[0] + 'http' + encodeURIComponent(url[1])
      next({
        path: allUrl,
      })
    } else {
      next({
        path: to.path,
      })
    }

  }
  next()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;
